<template>
  <el-form-item :label="label" :error="error">
    <el-switch
      v-model="withLimit"
      active-text="With limit"
      inactive-text="Unlimited"
    />
    <div v-show="withLimit">
      <el-input-number
        v-model="model.value"
        :min="1"
        controls-position="left"
        @update:modelValue="update"
      />
    </div>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import {
  CampaignClickLimitType,
  CampaignValidationErrorsKey
} from '@/api/types'
import useValidation from '@/hooks/useValidation'

const LABELS: { [key in CampaignClickLimitType]: string } = {
  clicks_total: 'Total impressions',
  clicks_hourly: 'Impressions per hour',
  clicks_daily: 'Impressions per day',
  clicks_spot_hourly: 'Impressions per spot per hour',
  clicks_domain_hourly: 'Impressions per domain per hour'
}

export default defineComponent({
  name: 'ClickLimits',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const model = ref(props.modelValue)
    const withLimit = ref(model.value.value !== undefined)

    watch(withLimit, (newValue, _oldValue) => {
      if (newValue === false) {
        context.emit('remove', model.value.type_id)
      }
    })

    const label = computed(() => {
      return LABELS[model.value.type_id as CampaignClickLimitType]
    })

    function update(newValue: number) {
      context.emit('update:modelValue', {
        type_id: model.value.type_id,
        value: newValue
      })
    }

    const { validationErrors } = useValidation(CampaignValidationErrorsKey)
    const errors = validationErrors()

    const error = computed(() => {
      return errors.value ? errors.value[model.value.type_id] : ''
    })

    return { label, update, withLimit, error, model }
  }
})
</script>
<style scoped lang="scss">
:deep(.el-switch) {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
</style>
